import React from "react";
import {ResponsiveBar} from "@nivo/bar";

export default function BarChart(props) {
  return (
    <div style={{height: "600px", width: "100%", display: props.display ? "initial" : "none"}}>
      <ResponsiveBar /* or Bar for fixed dimensions */
        data={props.data}
        keys={Object.keys(props.data[0])?.filter(el => el != "created_at")}
        indexBy="created_at"
        valueScale={{type: "symlog", nice: true, round: false}}
        groupMode="grouped"
        labelSkipWidth={12}
        labelSkipHeight={12}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            translateX: 120,
            itemsSpacing: 3,
            itemWidth: 100,
            itemHeight: 16
          }
        ]}
        axisBottom={{legend: "Date", legendOffset: 32}}
        axisLeft={{legend: "Failure Code", legendOffset: -40}}
        margin={{top: 50, right: 130, bottom: 50, left: 60}}
      />
    </div>
  );
}
